import { RCPOProductCard } from './ProductCard'
import { RCPOProductCardLoading } from './ProductCardLoading'
import LocalizedLink from '@components/Localization/LocalizedLink'
import Indicators from '@components/_rolex/sliders/Indicators'
import { Container, Track, useSlider } from '@components/gassan-ui'
import { Button } from '@components/old-rolex-ui'
import { useArticlesQuery } from '@generated'
import { useTranslation } from 'next-i18next'
import { FC, useRef } from 'react'

type RCPOLatestWatchesProps = {
  buttonTitle: string
}

export const RCPOLatestWatches: FC<RCPOLatestWatchesProps> = ({ buttonTitle }) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { onTouchEnd, index } = useSlider({
    trackRef,
  })
  const { t } = useTranslation('navigation')
  const [{ fetching, data }] = useArticlesQuery({
    variables: {
      pagination: {
        limit: 3,
      },
      filters: {
        webID: 'gpcpreown',
        collections: [1],
      },
    },
  })

  const items = data?.articles?.items

  return (
    <Container className="mx-auto flex w-full !max-w-[1120px] flex-col items-center gap-4 py-8 md:gap-12">
      <div className="hidden w-full grid-cols-2 gap-4 md:grid md:grid-cols-6">
        {fetching || !data || !items ? (
          <>
            <RCPOProductCardLoading />
            <RCPOProductCardLoading />
            <RCPOProductCardLoading />
          </>
        ) : (
          items.map((item: any) => <RCPOProductCard key={item.id} data={item} />)
        )}
      </div>
      <div className="block md:hidden">
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {fetching || !data || !items ? (
            <div className="mb-8 min-w-full snap-start">
              <RCPOProductCardLoading />
            </div>
          ) : (
            items.map((item: any) => (
              <div key={item.id} className="mb-8 min-w-full snap-start">
                <RCPOProductCard data={item} />
              </div>
            ))
          )}
        </Track>
        <Indicators activeIndex={index} variant="static" count={items?.length || 0} />
      </div>
      <LocalizedLink href={t(`rcpo.selection.url`, { ns: 'navigation' })}>
        <Button>{buttonTitle}</Button>
      </LocalizedLink>
    </Container>
  )
}
